import { PopoverInstance, PopoverWidget } from '@tableau/widgets';
import { WorkbookTemplateDescriptionSmall } from '@tableau/workbook-templates-widgets';
import React from 'react';
import { classes } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { CARD_POPOVER_WIDTH, CardViewStyles, THUMBNAIL_BORDER_HEIGHT, THUMBNAIL_HEIGHT } from '~src/spacesPlatform/components/card/CardViewStyles';
import { DetailButton } from '~src/spacesPlatform/components/header/DetailButton';

import { StartersDialogClickSourceOptions } from '../../commonInfra/telemetryEvents/TelemetryEvents';
import * as StartersStyles from '../styles/StarterStyles';
import { Starter } from '../types/StartersTypes';
import { displayDialogWithTemplate } from './InteractiveStarterModal';

export interface StartersCardProps {
  starter: Starter;
  startersGroupedByConnectionType: Starter[];
  moreLikeThisLink: string;
  testId: string;
}

export class StartersCard extends React.PureComponent<StartersCardProps> {
  private popoverRef: React.RefObject<PopoverInstance> = React.createRef();

  public render() {
    const {starter, testId, startersGroupedByConnectionType, moreLikeThisLink} = this.props;
    return <div className={CardViewStyles.Card} data-tb-test-id={testId}>
      <CardThumbnail
        starter={starter}
        startersGroupedByConnectionType={startersGroupedByConnectionType}
        moreLikeThisLink={moreLikeThisLink}
        testId={testId}
      />
      <div className={CardViewStyles.ActionRow}>
        <h3>
          <span
              title={L10n.elideIfLong(starter.connectionType.displayName)}
              className={CardViewStyles.ActionRowName}
              data-tb-test-id={`${testId}-description`}>
            {L10n.elideIfLong(starter.connectionType.displayName)}
          </span>
        </h3>
        <span>
          <PopoverWidget
            ref={this.popoverRef}
            popoverContent={this.renderPopoverContent()}
            title={Messages.acceleratorDetails()}
            triggerElement={<DetailButton testId={`${starter.id}-starter-popover-trigger`} />}
            width={CARD_POPOVER_WIDTH}
          />
        </span>
      </div>
    </div>;
  }

  private renderPopoverContent = () =>
    <WorkbookTemplateDescriptionSmall starter={this.props.starter} handleClick={this.handleToolTipClick}/>;

  private handleToolTipClick = () => {
    this.popoverRef.current?.toggle(false);
    displayDialogWithTemplate(
      this.props.starter,
      this.props.startersGroupedByConnectionType,
      StartersDialogClickSourceOptions.HomeCardMoreLikeThis,
      this.props.startersGroupedByConnectionType.findIndex(
        (starterInternal: Starter) => starterInternal === this.props.starter
      )
    );
  };
}


export class CardThumbnail extends React.PureComponent<StartersCardProps> {

  private displayDialog = (source: StartersDialogClickSourceOptions): void => {
    displayDialogWithTemplate(
      this.props.starter,
      this.props.startersGroupedByConnectionType,
      source,
    );
  };

  private handleKeyDown = (e: React.KeyboardEvent<HTMLElement>): void => {
    if (e.key === 'Enter') {
      this.displayDialog(StartersDialogClickSourceOptions.HomeCard);
    }
  };

  public render() {
    return <>
      <button
        className={classes(CardViewStyles.Thumbnail, CardViewStyles.ThumbnailFocus, StartersStyles.StartersCardThumbnail)}
        style={{ backgroundImage: `url('${this.props.starter.thumbnailUrl}')`, backgroundSize: 'contain', backgroundPositionX: 'center', backgroundPositionY: 'top',
          /** override button browser default styles, default button `box-sizing` is `border-box` so override height */
          padding: 0, boxSizing: 'border-box', height: THUMBNAIL_HEIGHT + THUMBNAIL_BORDER_HEIGHT, width: '100%' }}
        onClick={() => this.displayDialog(StartersDialogClickSourceOptions.HomeCard)}
        data-tb-test-id={`${this.props.testId}-thumbnail`}
        onKeyDown={this.handleKeyDown}
        aria-haspopup={'dialog'}
        aria-label={this.props.starter.connectionType.displayName}
      ></button>
    </>;
  }
}

